import { Heading, Img, Stack, Text, VStack } from '@chakra-ui/react';

import { PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';

export const QrCodeSection = () => {
  const { content } = usePageTextContent<StoresPageContent>();

  const { title, description, qrCodeImageUrl, explanation } = content.qrCode;

  return (
    <PageContainer bgGradient="linear(to-r, orange.300, orange.600)">
      <PageContent align="center">
        <Stack
          align="center"
          direction={['column', 'column', 'row']}
          spacing="2.25rem"
        >
          <VStack align="flex-start" spacing="5rem">
            <VStack align="flex-start" spacing="1rem" color="white">
              <Heading fontSize="1.5rem">{title}</Heading>

              <Text
                fontSize="1.125rem"
                w={['full', 'full', '39rem']}
                style={{ columns: '18.75rem auto' }}
              >
                {description}
              </Text>
            </VStack>
          </VStack>

          <Stack
            direction={['column', 'column', 'column', 'row']}
            align="center"
            spacing="2.25rem"
          >
            <Img
              src={qrCodeImageUrl}
              rounded="lg"
              shadow="xl"
              w="full"
              maxW={['18.75rem', '18.75rem', '12rem', '18.75rem']}
              alt="QR Code"
              loading="lazy"
            />

            <Text
              fontSize="0.875rem"
              color="white"
              fontStyle="italic"
              textAlign={['center', 'center', 'center', 'unset']}
            >
              {explanation}
            </Text>
          </Stack>
        </Stack>
      </PageContent>
    </PageContainer>
  );
};
